import React from 'react';
import styles from './searchbox.module.scss';
import useTranslation from 'next-translate/useTranslation';

export default function Searchbox(): JSX.Element {
  const { t } = useTranslation('application');
  return (
    <div>
      <form className={styles.searchBox}>
        <div className={styles.searchBoxBackground}>
          <input
            type="search"
            name="q"
            defaultValue={''}
            placeholder={t('search_placeholder')}
            title={''}
            aria-autocomplete="both"
            style={{ flexGrow: 2, position: 'relative' }}
          />
          <img
            width="25px"
            height="38px"
            src="https://f.wishabi.net/creative/Distribution/images/icons/search-outline-default5.svg"
            alt=""
          />
        </div>
      </form>
    </div>
  );
}
